module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門3_3.25b16be5.png";